import Info from './info/info.js';

function Antigos() {
    return (
        <Info
            title="Informações para alunos antigos"
            htmlFileName="./antigos.html"
        />
    );
}

export default Antigos;